import axios from 'axios';
import tools from "@/composables/tools";

export interface RecaudacionCoordinador {
    id: number;
    coordinador_id: number;
    cantidad: number;
    notas: string | null;
    fecha_registro: Date;
    created_at: Date;
    updated_at: Date;
    coordinador?: {
        id: number;
        name: string;
    };
}

class RecaudacionServiceClass {
    /**
     * Registra una nueva recaudación
     */
    async registrar(cantidad: number, notas?: string): Promise<RecaudacionCoordinador | null> {
        try {
            const response = await axios.post('galidancia/recaudacion', {
                cantidad,
                notas: notas || ''
            });
            tools().toast('Recaudación registrada correctamente', 'success', 3000);
            return response.data.data;
        } catch (error) {
            tools().setLog('No se pudo registrar la recaudación', 'error');
            tools().toast('Error al registrar la recaudación', 'danger', 5000);
            return null;
        }
    }

    /**
     * Obtiene el historial de recaudaciones
     */
    async getHistorial(coordinadorId?: number, page?: number, perPage?: number): Promise<any> {
        try {
            const params: any = { page: page || 1, per_page: perPage || 20 };
            if (coordinadorId) {
                params.coordinador_id = coordinadorId;
            }
            const response = await axios.get('galidancia/recaudacion', { params });
            return response.data;
        } catch (error) {
            tools().setLog('No se pudo cargar el historial', 'error');
            tools().toast('Error al cargar el historial', 'danger', 5000);
            return null;
        }
    }

    /**
     * Verifica el estado de recaudación del coordinador
     */
    async checkStatus(): Promise<{
        necesita_registro: boolean;
        dias_sin_registro: number;
        ultimo_registro: Date | null;
    } | null> {
        try {
            const response = await axios.get('galidancia/recaudacion/check-status');
            return response.data;
        } catch (error) {
            tools().setLog('No se pudo verificar el estado', 'error');
            return null;
        }
    }

    /**
     * Obtiene todas las recaudaciones (admin)
     */
    async getAll(desde?: string, hasta?: string, page?: number, perPage?: number): Promise<any> {
        try {
            const params: any = { page: page || 1, per_page: perPage || 20 };
            if (desde) params.desde = desde;
            if (hasta) params.hasta = hasta;
            
            const response = await axios.get('galidancia/recaudacion/all', { params });
            return response.data;
        } catch (error) {
            tools().setLog('No se pudo cargar las recaudaciones', 'error');
            tools().toast('Error al cargar las recaudaciones', 'danger', 5000);
            return null;
        }
    }
}

export default new RecaudacionServiceClass();